module.exports = __webpack_public_path__ + "static/media/video.a5dc3bb3.mp4";